import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'app-send-email-drawer',
    templateUrl: './send-email-drawer.component.html',
    standalone: false
})
export class SendEmailDrawerComponent {
  public sendEmailForm!: FormGroup;
  @Output() sendEmail: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('sendEmailDrawer', { static: true }) drawer!: MatSidenav;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.sendEmailForm = this.formBuilder.group({
      emailAddress: ['', [Validators.required, Validators.email]],
    });
  }

  public toggleSendEmail() {
    if (this.drawer) {
      this.sendEmailForm.reset();
      this.drawer.toggle();
    }
  }

  public onSendEmail() {
    this.sendEmail.emit(this.sendEmailForm.get("emailAddress")?.value);
  }
}
